export default {
  loading: false,
  isLoggedIn: !!localStorage.getItem("token"),
  isDark: localStorage.getItem("isDark") == 'true'
};
